import { render, staticRenderFns } from "./LightingDevice.vue?vue&type=template&id=2324e0d0&"
import script from "./LightingDevice.vue?vue&type=script&lang=js&"
export * from "./LightingDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports